import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login.vue';
import UserService from '@/services/UserService';
import store from '@/store';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false,
      showInNav: false,
      title: 'Login',
    },
  },
  {
    path: '/posts',
    name: 'posts',
    props: true,
    component: () => import(/* webpackChunkName: "mainView" */ '@/views/MainView.vue'),
    redirect: { name: 'postOverview' },
    meta: {
      auth: true,
      showInNav: true,
      title: 'Beiträge',
    },
    children: [
      {
        path: 'overview',
        name: 'postOverview',
        component: () => import(/* webpackChunkName: "postOverview" */ '@/views/posts/PostList.vue'),
        meta: {
          auth: true,
          showInNav: true,
          title: 'Alle Beiträge',
        },
      },
      {
        path: 'create',
        name: 'postCreate',
        component: () => import(/* webpackChunkName: "postEditCreate" */ '@/views/posts/PostCreateEdit.vue'),
        meta: {
          auth: true,
          showInNav: true,
          title: 'Beitrag erstellen',
        },
      },
      {
        path: 'edit/:id',
        name: 'postEdit',
        component: () => import(/* webpackChunkName: "postEditCreate" */ '@/views/posts/PostCreateEdit.vue'),
        props: true,
        meta: {
          auth: true,
          showInNav: false,
          title: 'Beitrag bearbeiten',
        },
      },
    ],
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import(/* webpackChunkName: "mainView" */ '@/views/MainView.vue'),
    redirect: { name: 'categoryOverview' },
    props: true,
    meta: {
      auth: true,
      showInNav: true,
      title: 'Kategorien',
    },
    children: [
      {
        path: 'overview',
        name: 'categoryOverview',
        component: () => import(/* webpackChunkName: "categoryOverview" */ '@/views/categories/CategoryList.vue'),
        meta: {
          auth: true,
          showInNav: true,
          title: 'Übersicht',
        },
      },
      {
        path: 'create',
        name: 'categoryCreate',
        component: () => import(/* webpackChunkName: "categoryCreateEdit" */ '@/views/categories/CategoryCreateEdit.vue'),
        props: true,
        meta: {
          auth: true,
          showInNav: true,
          title: 'Kategorie erstellen',
        },
      },
      {
        path: 'edit/:id',
        name: 'categoryEdit',
        component: () => import(/* webpackChunkName: "categoryCreate" */ '@/views/categories/CategoryCreateEdit.vue'),
        props: true,
        meta: {
          auth: true,
          showInNav: false,
          title: 'Kategorie bearbeiten',
        },
      },
    ],
  },

  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "mainView" */ '@/views/MainView.vue'),
    redirect: { name: 'userOverview' },
    props: true,
    meta: {
      auth: true,
      showInNav: true,
      title: 'Benutzer',
    },
    children: [
      {
        path: 'overview',
        name: 'userOverview',
        component: () => import(/* webpackChunkName: "categoryOverview" */ '@/views/users/UserList.vue'),
        meta: {
          auth: true,
          showInNav: true,
          title: 'Übersicht',
        },
      },
      {
        path: 'create',
        name: 'userCreate',
        component: () => import(/* webpackChunkName: "categoryCreateEdit" */ '@/views/users/UserCreateEdit.vue'),
        props: true,
        meta: {
          auth: true,
          showInNav: true,
          title: 'Benutzer erstellen',
        },
      },
      {
        path: 'edit/:id',
        name: 'userEdit',
        component: () => import(/* webpackChunkName: "categoryCreate" */ '@/views/users/UserCreateEdit.vue'),
        props: true,
        meta: {
          auth: true,
          showInNav: false,
          title: 'Benutzer bearbeiten',
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/login',
    meta: {
      auth: false,
      showInNav: false,
    },
  },
];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const { isUserLoggedIn } = store.getters;
  const routeIsValid = !!to.matched.length;

  if (!routeIsValid && !isUserLoggedIn) {
    return next({ path: '/login' });
  }

  if ((!routeIsValid || to.path === '/login') && isUserLoggedIn) {
    return next({ path: '/dashboard' });
  }

  const authRequired = to.meta.auth;
  const tokenCookie = Vue.cookie.get('token');
  const userIdCookie = Vue.cookie.get('userId');
  const refreshToken = Vue.cookie.get('refreshToken');

  if (authRequired && tokenCookie && userIdCookie && !isUserLoggedIn) {
    UserService.findOne(userIdCookie)
      .then((response) => {
        const loginData = {
          user: response,
          token: {
            token: tokenCookie,
            refreshToken,
          },
        };
        store.commit('login', loginData);
        if (routeIsValid && to.path !== '/login') {
          return next();
        }

        return next({ path: '/settings/profile' });
      })
      .catch(() => next({ path: '/login' }));
  }

  if (authRequired && !tokenCookie) {
    return next({ path: '/login' });
  }

  return next();
});

export default router;
